import Modal from "../../../../shared/components/UI/Modal/Modal";
import "../../styles/modal/statsModal.scss"
import { displayNotImplemented } from "../../../../shared/services/Notifications/NotificationServices";
import useGetUserProfile from "../../hooks/useGetUserProfile";
import { FormatExperience } from "../../../../shared/shared";
import { useState } from "react";
import { displaySuccesCopyLink } from "../../../../shared/services/Notifications/NotificationServices";

interface ModalActivityProps {
    isModalOpen: boolean;
    setIsModalOpen: (isModalOpen: boolean) => void;
    username: string;
}

export default function ModalActivity({ isModalOpen, setIsModalOpen, username }: ModalActivityProps) {

    const { data, isLoading, error } = useGetUserProfile(username, 'statistics')

    function contentShared() {
        return (
            <button className="modal-content__share-button">
                <p>Поделиться</p>
            </button>
        )
    }

    function contentLinkClick(url: string) {
        if (navigator.clipboard) {
            navigator.clipboard.writeText(url)
                .then(() => {
                    displaySuccesCopyLink()
                })
        }
    }

    function contentLink() {
        let pageUrl = new URL(window.location.href);
        pageUrl.pathname = '/Cabinet/' + username;
        pageUrl.searchParams.set('statModal', 'true');
        let protocol = pageUrl.protocol.toString() + '//';
        const actualyUrl = pageUrl.toString().replace(protocol, '');
        return (
            <div className="modal-content__share-button" onClick={() => { contentLinkClick(actualyUrl) }}>
                <div className="modal-content__link-container" >
                    <p>{actualyUrl}</p>
                    <img src="/cabinet/copy.svg"></img>
                </div>
            </div>
        )
    }

    function Content() {
        const [link, setLink] = useState(contentShared());

        return (
            <div onClick={() => { setLink(contentLink()) }}>
                {link}
            </div>
        )
    }

    // const dataActivity = {
    //     "callsign": "Позывной",
    //     "avatar_link": "https://media.cybershtab.ru/cybershtab-local-bucket/images/users/avatars/1a3374cb-ffb0-47e4-94cc-fc8c3a6a4c76.jpg",
    //     "specialization": "Снайпер",
    //     "experience": "5 лет",
    //     "win_percentage": "61%",
    //     "efficiency": "0.39",
    //     "number_games": "115",
    //     "number_deaths": "368",
    //     "number_captured_points": "25",
    //     "favorite_weapons": {
    //       "name": "AR-15 (CYMA)",
    //       "type": {
    //         "name": "Винтовка",
    //         "image": "https://media.cybershtab.ru/cybershtab-local-bucket/images/weapons/types/1a3374cb-ffb0-47e4-94cc-fc8c3a6a4c76.jpg"
    //       },
    //       "firm_name": "CYMA"
    //     },
    //     "team": {
    //       "name": "СК Зенит",
    //       "avatar_link": "https://media.cybershtab.ru/cybershtab-local-bucket/images/teams/avatars/6d588e0c-6bea-446e-85f1-149df9d8dc8e.jpg",
    //       "slug": "Il-"
    //     }
    // }

    return (
        <Modal isOpen={isModalOpen} closeModal={() => {
            setIsModalOpen(false)
        }}>
            <div className="modal-content-wrapper">
                <div className="modal-content">
                    <div className="modal-content__statistics">
                        <div className="modal-content__statistics-header">
                            <div className="modal-content__statistics-header-about-player">
                                <img className="modal-content__statistics-header-about-player-avatar" src={data?.avatar_link != null ? data?.avatar_link : '../EmptyProfileSection/ava_empty.png'} alt="avatar" />
                                <img className="modal-content__statistics-header-about-player-team" src={data?.team?.avatar_link != null ? data?.team?.avatar_link : ' '} alt="team" onError={(e) => {
                                    e.currentTarget.style.display = 'none';
                                }} />
                                <div className="modal-content__statistics-header-about-player-info">
                                    <p className="modal-content__statistics-header-about-player-info-name">{data?.callsign}</p>
                                    <p className="modal-content__statistics-header-about-player-info-team">{data?.team?.name}</p>
                                </div>
                            </div>
                            <div className="modal-content__statistics-header-percents">
                                <div className="modal-content__statistics-header-percents-wins">
                                    <div className="modal-content__statistics-header-percents-wins-percents">
                                        <p>{data?.win_percentage}%</p>
                                        <span>Процент побед</span>
                                    </div>
                                    <div className="modal-content__statistics-header-percents-wins-arrow">
                                        <div className="modal-content__statistics-header-percents-wins-arrow-1"></div>
                                        <div className="modal-content__statistics-header-percents-wins-arrow-2"></div>
                                        <div className="modal-content__statistics-header-percents-wins-arrow-3"></div>
                                    </div>
                                </div>
                                <div className="modal-content__statistics-header-percents-effectiveness">
                                    <div className="modal-content__statistics-header-percents-effectiveness-percents" >
                                        <p>{data?.efficiency}</p>
                                        <span>Эффективность</span>
                                    </div>
                                    <div className="modal-content__statistics-header-percents-effectiveness-arrow">
                                        <div className="modal-content__statistics-header-percents-effectiveness-arrow-1"></div>
                                        <div className="modal-content__statistics-header-percents-effectiveness-arrow-2"></div>
                                        <div className="modal-content__statistics-header-percents-effectiveness-arrow-3"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-content__statistics-body">
                            <div className="modal-content__statistics-body-table">
                                <div className="modal-content__statistics-body-table-stats">
                                    <p>Участие в играх:</p>
                                    <span>{data?.number_games}</span>
                                </div>
                                <div className="modal-content__statistics-body-table-stats">
                                    <p>Количество смертей:</p>
                                    <span>{data?.number_deaths}</span>
                                </div>
                                <div className="modal-content__statistics-body-table-stats">
                                    <p>Захвачено точек:</p>
                                    <span>{data?.number_captured_points}</span>
                                </div>
                                <div className="modal-content__statistics-body-table-stats">
                                    <p>Достижения:</p>
                                    <span>В разработке</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-content__about-player">
                        <div className="modal-content__about-player-header">
                            <div className="modal-content__about-player-header-container-for-img">
                                <img className="modal-content__about-player-header-container-for-img-bg" src="\CabAbout\background-net.svg" alt="" />
                                <img className="modal-content__about-player-header-container-for-img-img" src={data?.favourite_weapons?.type?.image || '/CabAbout/AR-15.svg'} alt={data?.favourite_weapons?.type?.name} />
                            </div>
                        </div>
                        <div className="modal-content__about-player-body">
                            <div className="modal-content__about-player-body-stats">
                                <p>Любимый привод</p>
                                <span>{data?.favourite_weapons?.name}</span>
                            </div>
                            <div className="modal-content__about-player-body-stats">
                                <p>Специализация:</p>
                                <span>{data?.user_main_spec?.name}</span>
                            </div>
                            <div className="modal-content__about-player-body-stats">
                                <p>Стаж игры:</p>
                                <span>{FormatExperience(data?.experience)}</span>
                            </div>
                        </div>
                    </div>
                    {Content()}
                </div>
            </div>
        </Modal>
    )
}